export default {
  // Primary variant (default) - suitable for main site/account pages
  primary: {
    container: "mb-6",
    list: "flex items-center space-x-2 text-sm",
    item: "flex items-center",
    itemContent: "flex items-center space-x-2",
    link: "flex items-center text-gray_2 hover:text-primary transition-colors cursor-pointer",
    text: "flex items-center text-gray_2",
    current: "flex items-center text-primary font-medium",
    icon: "w-4 h-4 mr-1 flex-shrink-0",
    separator: "flex items-center text-gray_3 mx-2",
    separatorIcon: "w-4 h-4",
  },

  // Admin variant - consistent with admin panel styling
  admin: {
    container: "mb-4",
    list: "flex items-center space-x-2 text-sm",
    item: "flex items-center",
    itemContent: "flex items-center space-x-2",
    link: "flex items-center text-admin_text_secondary hover:text-admin_primary transition-colors cursor-pointer",
    text: "flex items-center text-admin_text_secondary",
    current: "flex items-center text-admin_primary font-medium",
    icon: "w-4 h-4 mr-1 flex-shrink-0",
    separator: "flex items-center text-admin_neutral_2 mx-2",
    separatorIcon: "w-4 h-4",
  },

  // Compact variant - smaller spacing and text
  compact: {
    container: "mb-3",
    list: "flex items-center space-x-1 text-xs",
    item: "flex items-center",
    itemContent: "flex items-center space-x-1",
    link: "flex items-center text-gray_2 hover:text-primary transition-colors cursor-pointer",
    text: "flex items-center text-gray_2",
    current: "flex items-center text-primary font-medium",
    icon: "w-3 h-3 mr-1 flex-shrink-0",
    separator: "flex items-center text-gray_3 mx-1",
    separatorIcon: "w-3 h-3",
  },

  // Large variant - bigger text and spacing for important navigation
  large: {
    container: "mb-8",
    list: "flex items-center space-x-3 text-base",
    item: "flex items-center",
    itemContent: "flex items-center space-x-3",
    link: "flex items-center text-gray_2 hover:text-primary transition-colors cursor-pointer font-medium",
    text: "flex items-center text-gray_2 font-medium",
    current: "flex items-center text-primary font-semibold",
    icon: "w-5 h-5 mr-2 flex-shrink-0",
    separator: "flex items-center text-gray_3 mx-3",
    separatorIcon: "w-5 h-5",
  },

  // Minimal variant - no background, minimal styling
  minimal: {
    container: "mb-2",
    list: "flex items-center space-x-2 text-sm",
    item: "flex items-center",
    itemContent: "flex items-center space-x-2",
    link: "flex items-center text-text_secondary hover:text-text transition-colors cursor-pointer",
    text: "flex items-center text-text_secondary",
    current: "flex items-center text-text",
    icon: "w-4 h-4 mr-1 flex-shrink-0",
    separator: "flex items-center text-text_tertiary mx-2",
    separatorIcon: "w-4 h-4",
  },

  // Card variant - with background and padding
  card: {
    container: "bg-paper rounded-lg p-4 mb-6 shadow-sm border border-bordered",
    list: "flex items-center space-x-2 text-sm",
    item: "flex items-center",
    itemContent: "flex items-center space-x-2",
    link: "flex items-center text-gray_2 hover:text-primary transition-colors cursor-pointer",
    text: "flex items-center text-gray_2",
    current: "flex items-center text-primary font-medium",
    icon: "w-4 h-4 mr-1 flex-shrink-0",
    separator: "flex items-center text-gray_3 mx-2",
    separatorIcon: "w-4 h-4",
  },

  // Admin card variant - admin styling with background
  admin_card: {
    container: "bg-admin_paper rounded-lg p-4 mb-4 shadow-sm border border-admin_bordered",
    list: "flex items-center space-x-2 text-sm",
    item: "flex items-center",
    itemContent: "flex items-center space-x-2",
    link: "flex items-center text-admin_text_secondary hover:text-admin_primary transition-colors cursor-pointer",
    text: "flex items-center text-admin_text_secondary",
    current: "flex items-center text-admin_primary font-medium",
    icon: "w-4 h-4 mr-1 flex-shrink-0",
    separator: "flex items-center text-admin_neutral_2 mx-2",
    separatorIcon: "w-4 h-4",
  },
}